import React from 'react';

const StipulationsPageMain = (props) => {

  return (
    <div id="content1200">
      <div className="companyTitle">
       	<span className="nielsen-navyBlack">약관 및 정책</span>
      </div>
      <div className="txt_box">
        <div className="privacy_titbox">1. 제1조 (목적)</div>
				(1) 본 약관의 내용은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지하고, 회원이 본 약관의 내용에 동의하여 자신에 대한 정보를 운영자에게 제출하면, 운영자가 그 신청을 전자우편 등을 통해 승인함으로써 효력이 발생한다.<br />
        (2) 운영자는 영업상 중요 사유 또는 관계 법령에 의한 변경사유가 있을 때, 약관을 변경할 수 있으며, 변경된 약관은 전항과 같은 방법으로 효력을 발생한다.
        <div className="privacy_titbox">2. 제2조 (약관의 공지 및 준용)</div>
        (1) 본 약관의 내용은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지하고, 회원이 본 약관의 내용에 동의하여 자신에 대한 정보를 운영자에게 제출하면, 운영자가 그 신청을 전자우편 등을 통해 승인함으로써 효력이 발생한다.<br />
        (2) 운영자는 영업상 중요 사유 또는 관계 법령에 의한 변경사유가 있을 때, 약관을 변경할 수 있으며, 변경된 약관은 전항과 같은 방법으로 효력을 발생한다.
        <div className="privacy_titbox">3. 제3조 (약관 외 준칙)</div>
        (1) 본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법 및 기타 관계 법령의 규정에 따른다.
        <div className="privacy_titbox">4. 제4조 (용어의 정의)</div>
        (1) 서비스: 운영자가 인터넷 상의 구전 데이터를 수집, 가공하여 새로이 산출한 데이터 및 관련 컨텐츠를 버즈워드 사이트(www.buzzword.co.kr)를 통하여 제공하는 것을 의미한다.<br />
        (2) 회원: 서비스의 이용을 신청하여 아이디를 부여 받은 개인, 개인사업자, 법인을 말한다.<br />
        (3) 아이디(ID): 회원의 식별과 서비스의 이용을 위해 회원이 선정하고 운영자가 부여한 문자와 숫자의 조합을 말한다.
        <div className="privacy_titbox">5. 제5조 (서비스 가입 절차)</div>
        (1) 운영자가 제공하는 서비스를 이용하기 위해 신청인은 본 약관에 동의하고 운영자가 정한 방법에 따라 가입신청을 하여야 한다.<br />
        (2) 신청인이 서비스 중 유료서비스를 선택하는 경우에는 운영자가 정한 방법에 따라 서비스 요금을 선불로 납입하여야 한다.<br />
        (3) 운영자는 다음의 각 호에 해당하는 경우에는 가입 신청을 거절할 수 있다.<br />
        ① 타인이나 타 법인의 명의를 도용하여 가입 신청을 하였을 경우.<br />
        ② 가입신청서의 내용을 허위로 기재하여 신청하였을 경우.<br />
        ③ 기타 운영자가 정한 이용 신청 요건이 미비한 경우.<br />
        (4) 신청이 거절되는 경우, 신청인은 운영자와 상의하여, 내용 조정을 거친 후 다시 신청 할 수 있다.
        <div className="privacy_titbox">6. 제6조 (운영자의 의무)</div>
        (1) 운영자는 회원이 본 약관에 동의하는 것을 조건으로 회원이 신청한 서비스를 성실히 제공한다.<br />
        (2) 운영자는 서비스 제공과 관련하여 알게 된 회원의 신상 정보를 회원 본인의 허락 없이 제3자에게 누설 배포하지 않는다.<br />
        단, 전기통신사업법 등 관련 법령의 규정에 의해 국가기관의 요구가 있는 경우, 수사기관 또는 정보통신 윤리위원회 기타 공공기관의 요청이 있는 경우, 또는 기타 관계 법령에서 정한 절차에 따른 요청이 있는 경우는 예외로 한다.<br />
        (3) 운영자는 회원의 이용 편의를 위하여 별도로 정한 기준에 의해 유료서비스 혜택을 무상으로 제공할 수 있다.
        <div className="privacy_titbox">7. 제7조 (회원의 의무)</div>
        (1) 회원은 자신의 아이디, 비밀 번호에 관한 모든 관리의 책임을 가진다. 부여된 아이디와 비밀번호의 관리 부주의로 인한 부정사용으로 발생하는 모든 결과에 대한 책임은 회원에게 있다.<br />
        (2) 회원이 약관에 위반되는 행위로 인해 발생한 결과에 대하여 운영자는 책임을 지지 않는다. 회원은 이와 같은 행위로 운영자에게 손해를 끼칠 경우 이에 대한 손해배상 의무를 진다.<br />
        (3) 회원은 본 약관 및 관계법령에서 규정한 사항을 준수하여야 한다.<br />
        (4) 자신의 아이디(ID)가 부정하게 사용된 것을 알게 된 경우 회원은 운영자에게 그 사실을 즉시 통보해야 한다.<br />
        (5) 회원은 서비스의 이용권한을 타인에게 양도, 대여 및 기타 처분할 수 없다.
        <div className="privacy_titbox">8. 제8조 (서비스의 제공)</div>
        (1) 서비스 이용은 회원이 본 약관에 동의하고 운영자가 정한 가입 절차를 완료함으로써 가능하다. 단, 유료서비스의 경우는 요금 납입을 운영자가 확인한 직후부터 가능하다.<br />
        (2) 서비스의 이용은 운영자의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 한다. 다만 정기점검 또는 기술상의 문제 등의 필요로 운영자가 정한 날이나 시간은 그러하지 않다.<br />
        (3) 운영자는 다음 각 호에 해당하는 경우 서비스 제공을 중지할 수 있다.<br />
        ① 서비스용 설비의 보수 등 공사로 인한 부득이한 경우.<br />
        ② 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우.<br />
        ③ 기타 불가항력적 사유가 있는 경우.<br />
        (4) 운영자는 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 때에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있다. 이 경우 그 내용을 사전에 공지한다.
        <div className="privacy_titbox">9. 제9조 (서비스 이용 제한)</div>
        (1) 회원은 서비스 이용시 다음 각 호의 행위를 할 수 없으며 적발시 운영자는 서비스 이용을 중지시킬 수 있다.<br />
        ① 다른 회원의 아이디(ID)를 부정하게 사용하는 행위.<br />
        ② 서비스에서 얻은 정보를 운영자의 사전 허가 없이 제3자에게 공개 또는 배포하는 행위.<br />
        ③ 운영자 및 제3자의 저작권을 포함한 지적재산권 기타 권리를 침해하는 행위.<br />
        ④ 관계법령에 위배되는 행위.<br />
        ⑤ 기타 명백한 부정 행위.<br />
        ⑥ 운영자가 별도 공지를 통해 금지하는 행위
        <div className="privacy_titbox">10. 제10조 (서비스 내용의 변경)</div>
        (1) 서비스 내용이 추가, 변경되는 경우에 운영자는 사전에 이 내용을 웹사이트에 게시, 전자우편 등의 방법으로 공지한다.
        <div className="privacy_titbox">11. 제12조 (면책조항)</div>
        (1) 운영자는 무료 서비스 이용으로 회원에게 발생한 어떠한 손해에 대해서도 책임을 지지 않는다.<br />
        (2) 회원이 약관을 위반하거나 관계 법령을 위반하여 제3자 또는 운영자에 손해가 발생할 시에는, 회원은 운영자나 제3자에게 발생한 손해를 배상할 책임이 있다.<br />
        (3) 운영자는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제된다.<br />
        (4) 운영자는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않는다.<br />
        (5) 운영자는 회원이 서비스를 이용하여 기대하는 이익이나, 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않는다.<br /><br />
        [부 칙] (시행일) 이 약관은 2020년 7월 1일부터 시행한다.      
      </div>   
    </div>
  )
}

export default StipulationsPageMain;